/* hl-cart-badges — keep the payment logos at the foot of the cart drawer.

   Same shape as assets/hl-cart-tiers.js and for the same reason: the drawer's
   summary is replaced wholesale by the Section Rendering API on every cart
   change, so this has to re-seat rather than insert once, and every write is
   compared first so the observer cannot feed itself. */
(function () {
  var tpl = document.getElementById('hl-cart-badges-tpl');
  if (!tpl) return;

  function render() {
    var drawer = document.getElementById('cart-drawer');
    if (!drawer) return;
    var summary = drawer.querySelector('.cart-drawer__summary');
    if (!summary) return;

    var row = summary.querySelector('[data-hl-cb]');
    /* Last child of the summary: below Estimated total, below Check out, below
       the wallet buttons — "dưới cùng". */
    if (row && row === summary.lastElementChild) return;
    if (!row) row = tpl.content.firstElementChild.cloneNode(true);
    summary.appendChild(row);
  }

  var raf = 0;
  function schedule() {
    if (raf) return;
    raf = requestAnimationFrame(function () { raf = 0; render(); });
  }

  if (typeof MutationObserver === 'function') {
    /* Drawer mutations re-seat the row NOW (2026-09-23): the theme's morph drops
       it, and one rAF later was one painted frame with a summary 30px shorter —
       the badge row and its gap — which the summary's height animation then
       played as a drop and a rise on every add. */
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var t = muts[i].target;
        if (t && t.closest && t.closest('#cart-drawer')) {
          if (raf) { cancelAnimationFrame(raf); raf = 0; }
          render();
          return;
        }
      }
      schedule();
    }).observe(document.body, { subtree: true, childList: true });
  }
  document.addEventListener('cart:update', schedule);
  schedule();
})();
